import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

import TrialSetup from "../../components/setup/TrialSetup/TrialSetup";

const TrialSetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Trial Setup</VolunteerHeading>
      <TrialSetup />
    </MainDiv>
  );
};
export default TrialSetupPage;
